import $http from '../http'
import { baseUrl } from '../url'
const BASEURL = baseUrl.primary + '/v1'
const BASEURL2 = baseUrl.newprimary + '/v1'
const BASEURL_DEV = BASEURL

const Insurance = {
  UpdateOrderState(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Insurance/Company/UpdateOrderState`,
      data
    })
  },
  AllPage(params) {
    return $http({
      method: 'get',
      url: `${BASEURL}/Insurance/Company/AllPage`,
      params
    })
  },
  CompanyDetail(params) {
    return $http({
      method: 'get',
      url: `${BASEURL}/Insurance/Company/Detail`,
      params
    })
  },
  InsureUnitDelete(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Insurance/InsureUnit/Delete`,
      data,
    })
  },
  CheckOrderNo(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Insurance/Company/CheckOrderNo`,
      data
    })
  },
  GetOrderNo() {
    return $http({
      method: 'get',
      url: `${BASEURL}/Insurance/Company/GetOrderNo`
    })
  },
  SynchronizationThirdly(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Insurance/Company/SynchronizationThirdly`,
      data
    })
  },
  SubmitData(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Insurance/Company/SubmitData`,
      data
    })
  },
  SaveData(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Insurance/Company/SaveData`,
      data
    })
  },
  SynchronizationThirdlyInfo(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Insurance/Company/SynchronizationThirdlyInfo`,
      data
    })
  },
  SynchronizationThirdlyKeyVal(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Insurance/Company/SynchronizationThirdlyKeyVal`,
      data
    })
  },
  GetOrderInfo(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/ThirdParty/Insurance/YangGuang/GetOrderInfo`,
      data
    })
  },
  YangGuangOrderPrePerson(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/ThirdParty/Insurance/YangGuang/OrderPrePerson`,
      data
    })
  },
  YangGuangEnterpriseEdit(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/ThirdParty/Insurance/YangGuang/EnterpriseEdit`,
      data
    })
  },
  YangGuangEnterpriseAdd(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/ThirdParty/Insurance/YangGuang/EnterpriseAdd`,
      data
    })
  },
  ProductGetJobLevelListByCompany(params) {
    return $http({
      method: 'get',
      url: `${BASEURL}/Insurance/Product/GetJobLevelListByCompany`,
      params
    })
  },
  ProductSumInsuredList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL}/Insurance/Product/SumInsuredList`,
      params
    })
  },
  ProductGetJobLevelList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL}/Insurance/Product/GetJobLevelList`,
      params
    })
  },
  OrderPrePerson(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/ThirdParty/Insurance/YangGuang/OrderPrePerson`,
      data
    })
  },
  EnterpriseEdit(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/ThirdParty/Insurance/YangGuang/EnterpriseEdit`,
      data
    })
  },
  YangGuangRegister(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/ThirdParty/Insurance/YangGuang/Register`,
      data
    })
  },
  YangGuangControllersLogic(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/ThirdParty/Insurance/YangGuang/Logic`,
      data
    })
  },
  MatchingUnitInfo(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/Insurance/UnitMatching/MatchingUnitInfo`,
      data
    })
  },
  CheckThirdlyUnit(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/Insurance/UnitMatching/CheckThirdlyUnit`,
      data
    })
  },

  TheInsuredDetail(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/Insurance/Company/TheInsuredDetail`,
      params
    })
  },
  InsureUnitDetail(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/Insurance/InsureUnit/Detail`,
      params
    })
  },
  InsureUnitList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/Insurance/InsureUnit/List`,
      params
    })
  },
  InsureUnitEdit(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/Insurance/InsureUnit/Edit`,
      data
    })
  },
  InsureUnitPage(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/Insurance/InsureUnit/Page`,
      params
    })
  },
  CompanyRefreshState() {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/Insurance/Company/RefreshState`
    })
  },
  CompanyList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/Insurance/Company/List`,
      params
    })
  },
  TypeList(data) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/Insurance/Type/List`,
      data
    })
  },
  InsuranceCompanyCreateOrder(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/Insurance/Company/CreateOrder`,
      data
    })
  },
  InsuranceCompanyPage(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/Insurance/Company/Page`,
      params
    })
  },
  InsuranceWorkCategoryList() {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/Insurance/WorkCategory/List`
    })
  },
  InsuranceProductList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/Insurance/Product/List`,
      params
    })
  }
}

export default Insurance
